module.exports = __webpack_public_path__ + "static/media/error.25e013e6.svg";